export default "__VITE_ASSET__828093cb__"